import type {ReactAction} from '@netx/core/bootstrap';
import {faFileExport} from '@netx/core-icons';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {cartActionExportAttributesDownload} from './cart-export-attributes-download';
import {cartActionExportAttributesShareLink} from './cart-export-attributes-share-link';

/**
 * Download cart metadata
 * @param params
 * @returns Action
 */
export const cartActionExportAttributes = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-export-attributes',
	cb: () => {},
	icon: faFileExport,
	get label() {
		return CART_CURRENT_ACTION_LABELS.EXPORT_ATTRIBUTES;
	},
	children: [
		cartActionExportAttributesDownload(),
		cartActionExportAttributesShareLink(),
	],
	...params,
});

export default cartActionExportAttributes;
